import { render, staticRenderFns } from "./PricelistsEdit.vue?vue&type=template&id=e13e4ea0"
import script from "./PricelistsEdit.vue?vue&type=script&lang=js"
export * from "./PricelistsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports